export default () => {
  return useStatefulCookie<string | null>('access_token')
}
